// styling
import styled from 'styled-components/macro';
import { colors, textSizes, fonts, flex } from '@styles/vars';
import { darken } from 'polished';
import PropTypes from 'prop-types';

const Button = styled.button`
  border-radius: 8px;
  background-color: ${(props) => props.color || colors.blue};
  color: ${(props) => props.textcolor || colors.white};
  font-size: ${textSizes['14']};
  font-family: ${fonts.accent};
  height: 40px;
  width: 100%;
  display: flex;
  ${flex.center};
  gap: 8px;
  line-height: 1;
  transition: background-color var(--transition);
  border: ${(props) => (props.border ? `1px solid ${props.border}` : 'none')};
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${(props) => darken(0.1, props.color || colors.blue)};
  }

  &.success {
    background-color: ${colors.success};

    &:hover,
    &:focus {
      background-color: ${darken(0.1, colors.success)};
    }
  }

  &.error {
    background-color: ${colors.error};

    &:hover,
    &:focus {
      background-color: ${darken(0.1, colors.error)};
    }
  }

  &:disabled,
  &&.disabled {
    background-color: ${(props) => props.color || colors.blue};
    opacity: 0.6 !important;
    pointer-events: none;
    cursor: not-allowed;
  }
`;

const Btn = ({
  text,
  handler,
  type = 'button',
  isVisible = true,
  className,
  icon,
  color = colors.blue,
  disabled = false,
  ...props
}) => {
  if (!isVisible) {
    return null;
  }
  const mergedClass = [className, disabled ? 'disabled' : ''].filter(Boolean).join(' ');
  return (
    <Button
      className={mergedClass}
      onClick={disabled ? undefined : handler}
      type={type}
      color={color}
      disabled={disabled}
      aria-disabled={disabled}
      {...props}
    >
      {icon && <i className={`icon icon-${icon}`} />} {text}
    </Button>
  );
};

Btn.propTypes = {
  text: PropTypes.string.isRequired,
  handler: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  isVisible: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool
};

export default Btn;
